import {
    SOLICITAR_HISTORIA_CLINICA,
    SOLICITAR_HISTORIA_CLINICA_EXITO,
    SOLICITAR_HISTORIA_CLINICA_ERROR,
    MODIFICAR_HISTORIA_CLINICA,
    MODIFICAR_HISTORIA_CLINICA_EXITO,
    MODIFICAR_HISTORIA_CLINICA_ERROR,
    NUEVO_HISTORIA_CLINICA,
    NUEVO_HISTORIA_CLINICA_EXITO,
    NUEVO_HISTORIA_CLINICA_ERROR
} from '../types';

import clienteAxios from '../config/axios';

import Swal from 'sweetalert2';

const obtenerMensajeError = (error, mensajeDefault) => {
    return (
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        mensajeDefault
    );
};

export function historiaClinicaSolicitarAction(informacion) {
    return async (dispatch) => {
        dispatch(historiaClinicaSolicitar());

        try {
            const { config, payload } = informacion;

            const { data } = await clienteAxios.post(
                '/paciente/buscarhistoriaClinica',
                payload,
                config
            );

            dispatch(historiaClinicaSolicitarExito(data));

            return data;

        } catch (error) {
            const mensaje = obtenerMensajeError(
                error,
                'No se pudo cargar la historia clínica.'
            );

            dispatch(historiaClinicaSolicitarError(mensaje));

            return null;
        }
    };
}

const historiaClinicaSolicitar = () => ({
    type: SOLICITAR_HISTORIA_CLINICA,
    payload: true
});

const historiaClinicaSolicitarExito = (data) => ({
    type: SOLICITAR_HISTORIA_CLINICA_EXITO,
    payload: data
});

const historiaClinicaSolicitarError = (msg) => ({
    type: SOLICITAR_HISTORIA_CLINICA_ERROR,
    payload: msg
});

export function modificarHistoriaClinicaAction(informacion) {
    return async (dispatch) => {
        dispatch(modificarHistoriaClinica());

        try {
            const { config, payload } = informacion;

            const { data } = await clienteAxios.put(
                '/paciente/modificarhistoriaclinica',
                payload,
                config
            );

            dispatch(modificarHistoriaClinicaExito(true));

            // El backend devuelve la historia clínica actualizada del paciente.
            dispatch(historiaClinicaSolicitarExito(data));

            // Importante:
            // No mostramos SweetAlert acá porque el modal de HC queda por encima
            // y puede dejar el flujo esperando para siempre.
            return true;

        } catch (error) {
            const mensaje = obtenerMensajeError(
                error,
                'La información clínica no se pudo guardar.'
            );

            dispatch(modificarHistoriaClinicaError(mensaje));

            // Tampoco hacemos await Swal.fire acá.
            // El componente decide qué hacer con el error.
            return false;
        }
    };
}

const modificarHistoriaClinica = () => ({
    type: MODIFICAR_HISTORIA_CLINICA,
    payload: true
});

const modificarHistoriaClinicaExito = (cambios) => ({
    type: MODIFICAR_HISTORIA_CLINICA_EXITO,
    payload: cambios
});

const modificarHistoriaClinicaError = (msg) => ({
    type: MODIFICAR_HISTORIA_CLINICA_ERROR,
    payload: msg || true
});

export function historiaClinicaNuevosAction(informacion) {
    return async (dispatch) => {
        dispatch(historiaClinicaNuevos());

        try {
            const { config, payload } = informacion;

            const { data } = await clienteAxios.post(
                '/paciente/nuevohistoriaclinica',
                payload,
                config
            );

            dispatch(historiaClinicaNuevosExito());

            Swal.fire(
                'Correcto',
                'El objetivo se agregó correctamente',
                'success'
            );

            dispatch(historiaClinicaSolicitarExito(data));

            return true;

        } catch (error) {
            const mensaje = obtenerMensajeError(
                error,
                'El objetivo no se pudo agregar correctamente'
            );

            dispatch(historiaClinicaNuevosError(true));

            Swal.fire(
                'Error',
                mensaje,
                'error'
            );

            return false;
        }
    };
}

const historiaClinicaNuevos = () => ({
    type: NUEVO_HISTORIA_CLINICA,
    payload: true
});

const historiaClinicaNuevosExito = () => ({
    type: NUEVO_HISTORIA_CLINICA_EXITO,
    payload: true
});

const historiaClinicaNuevosError = (estado) => ({
    type: NUEVO_HISTORIA_CLINICA_ERROR,
    payload: estado
});